import React, { Component } from "react";
import { HashRouter as Router, Route, Switch } from "react-router-dom";
import LoginForm from "./components/authentication/LoginForm";
import Homepage from "./components/homepage/Homepage";
import ModalManager from "./components/sub/modals/ModalManager";
import NotFound from "./components/NotFound";
import axios from "axios";
import APIUrl from "./APIUrl";
import { connect } from "react-redux";
import { FormattedMessage } from "react-intl";
import { logout } from "./actions/authentication/authentication";
import Util from "./util/Util";
import "bootstrap/dist/css/bootstrap.min.css";
import "./css/bootstrap-fix.css";

// Configure Axios for CORS requests
axios.defaults.headers.post["Content-Type"] = "application/json";
axios.defaults.withCredentials = true;

// Used to keep connexion alive (using page refresh)
var sessionJWT = sessionStorage.getItem("jwt");
if (sessionJWT) {
  axios.defaults.headers.common["jwtToken"] = sessionJWT;
  APIUrl.jwtToken = sessionJWT;
}

class App extends Component {
  constructor(props) {
    super(props);

    this.state = { modal: null };

    // Using interceptors for cross-request handling of errors
    axios.interceptors.response.use(undefined, (err) => {
      // If we get a 500 from server stop the chain
      if (err.response && err.response.status === 500) {
        const errorMessage =
          err.response &&
          err.response.hasOwnProperty("data") &&
          err.response.data &&
          err.response.data.hasOwnProperty("message")
            ? err.response.data.message
            : null;

        this.openErrorModal(errorMessage);

        return new Promise(() => {});
      } else if (err.response && err.response.status === 403) {
        const hash = window.location.hash;

        window.location.replace(Util.checkHttps(process.env.REACT_APP_LOGIN_URL));

        if (hash.indexOf("home") !== -1) return new Promise(() => {});
      } else throw err;
    });
  }

  logout() {
    function onLogoutSuccess() {
      return window.location.replace(Util.checkHttps(process.env.REACT_APP_LOGIN_URL));
    }

    // Remove the modal, logout and redirect on success
    this.setState({ modal: null }, () => this.props.onLogout(onLogoutSuccess));
  }

  openErrorModal(errorMessage) {
    var errorModalTitle = <FormattedMessage id="Unexpected.Error" />;
    var errorModalContent = (
      <>
        <p>
          <FormattedMessage id="Unexpected.Error.Expl" />
        </p>
        <p>
          <strong>{errorMessage}</strong>
        </p>
        <FormattedMessage id="Redirect.To.Home" />
      </>
    );

    this.setState({
      modal: (
        <ModalManager
          showModal={true}
          title={errorModalTitle}
          content={errorModalContent}
          closeModal={(e) => this.logout()}
          modalType="error"
        />
      ),
    });
  }

  render() {
    return (
      <React.Fragment>
        <Router basename={"/"} refresh={true}>
          <Switch>
            <Route path="/home" component={Homepage} />
            <Route exact path="/:jwtToken?" component={LoginForm} />
            <Route component={NotFound} />
          </Switch>
        </Router>

        {this.state.modal}
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    lang: state.user.lang,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onLogout: (successCallback) => dispatch(logout(successCallback)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(App);
